var exports = {
  "R": "xe533113f--d550b0--branding-level-wrapper",
  "X": "xe533113f--d550b0--platinum",
};

module.exports = exports;
